import React, { useEffect, useState } from "react";
import "./Availability.css";
import TimeSelector from "./TimeSelector";
import url from "../../../Utility/URL/url";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Utility/loader/Loader";
import Configuration from "./Configuration";
import authHeader from "../../../headerTokenUtility/auth.header";
import getUsernameFromSession from "../../../Utility/gettingInformation/getUsernameFromSession";

function Availability() {
  const headerButtons = ["Schedule", "Calendar"];
  const [selectedHeader, setSelectedHeader] = useState("Schedule");
  const [availabilityDetails, setAvailabilityDetails] = useState();
  const [loading, setLoading] = useState(true);
  const username = getUsernameFromSession();

  const handleChangeButton = (value) => {
    setSelectedHeader((currValue) => (currValue !== value ? value : currValue));
  };

  useEffect(() => {
    getAvailabilityDetails();

    return () => {
      //component unmount cancel any pending request.
    };
  }, []);
  async function getAvailabilityDetails() {
    try {
      if (username) {
        const response = await axios.get(
          url.GET_AVAILABILITY_DETAILS + username,
          {
            headers: authHeader(),
          }
        );
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          const newAvailability = response.data;
          setAvailabilityDetails((currAvailability) =>
            currAvailability !== newAvailability
              ? newAvailability
              : currAvailability
          );
          setLoading(() => false);
        }

        setLoading(() => false);
      }
    } catch (error) {
      toast.warning("Technical Error while fetching the availability Details", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }

  const handleTimeChange = (timeType, time, index) => {
    if (timeType === "start") {
      //need to change the startTime of the current Index.
      const newAvailability = [...availabilityDetails];
      const changingObject = newAvailability[index];

      const [, secondKey] = Object.keys(changingObject);

      changingObject[secondKey].startTime = time;
      newAvailability[index] = changingObject;
      setAvailabilityDetails((currAvail) => {
        return currAvail !== newAvailability ? newAvailability : currAvail;
      });
    } else {
      //need to change the endTime of the current index.
      const newAvailability = [...availabilityDetails];
      const changingObject = newAvailability[index];

      const [, secondKey] = Object.keys(changingObject);
      changingObject[secondKey].endTime = time;
      newAvailability[index] = changingObject;
      setAvailabilityDetails((currAvail) => {
        return currAvail !== newAvailability ? newAvailability : currAvail;
      });
    }
  };

  const handleCheckBox = (event, index) => {
    const { checked, name } = event.target;

    setAvailabilityDetails((prevState) => {
      const newState = prevState.map((week, i) => {
        if (i === index) {
          const updatedWeek = { ...week };
          updatedWeek[name] = checked ? 1 : 0;
          return updatedWeek;
        }
        return week;
      });

      return prevState !== newState ? newState : prevState;
    });
  };
  const saveAvailability = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(
          url.UPDATE_AVAILABILITY_DETAILS + username,
          availabilityDetails,
          {
            headers: authHeader(),
          }
        );
        resolve(response);
        getAvailabilityDetails();
      } catch (error) {
        reject(error);
      }
    });
  };
  const handleSaveButton = () => {
    toast.promise(saveAvailability(), {
      pending: "updating availability",
      success: "Updated successfully",
      error: "Some technical isssue while updating the availability",
    });
  };
  return (
    <div
      className="availability"
      style={{ background: "rgb(248, 249, 252)", height: "100%" }}
    >
      <div className="header" style={{ background: "white" }}>
        <div className="header-title flex-row">
          <p
            className="text-start fs-3 pb-0 fw-bold"
            style={{ padding: "10px 0" }}
          >
            Availability
          </p>
          <p className="header-subtitle pb-2">
            Set your available times for bookings
          </p>
        </div>

        <div
          className="header-buttons"
          style={{
            borderTop: "1px solid rgb(229, 231, 235)",
            paddingTop: "25px",
            paddingLeft: "23px",
            background: "#f8fafc",
          }}
        >
          {/* <div
            className="d-flex flex-row flex-wrap justify-content-start"
            style={{ gap: "1rem" }}
          >
            {headerButtons.map((btn) => (
              <button
                className={`btn btn-outline-secondary rounded-pill hover-shadow text-dark border-dark  ${
                  selectedHeader === btn ? `selected-availability-header` : ""
                }`}
                onClick={() => handleChangeButton(btn)}
                value={btn}
              >
                {btn}
              </button>
            ))}
          </div> */}
        </div>
      </div>
      {/* <hr /> */}

      <div className="main">
        <div className="availability-main">
          {loading ? (
            <Loader />
          ) : (
            <div className=" availability-tabs">
              <div className="" style={{ padding: "3px 27px" }}>
                <div className="availability-grid">
                  <div
                    className="schedule-card"
                    // style={{ paddingLeft: "10px", paddingRight: "10px" }}
                  >
                    <div className="card-header">
                      <div>
                        <h2>Weekly Schedule</h2>
                        <p className="card-subtitle">
                          Set your available hours for each day
                        </p>
                      </div>
                      {/* <button class="btn-icon" title="Quick fill">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M9 3V9M9 9V15M9 9H15M9 9H3" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
                            </svg>
                        </button> */}
                    </div>
                    <div className="">
                      <div className=" add-slots">
                        {availabilityDetails?.map((week, index) => {
                          const keys = Object.keys(week);
                          const [firstKey, secondKey] = keys;

                          const weekName =
                            firstKey.charAt(0).toUpperCase() +
                            firstKey.slice(1);

                          return (
                            <div className={`week-block ${
                                  week[firstKey] === 1 ? "active" : "unavailable"
                                }`}>
                              {/* -------- ROW 1 (Checkbox + Day + Unavailable) -------- */}
                              <div
                                className=" slot-item "
                              >
                                <div className="day-header">
                                <div className=" d-flex align-items-center" style={{width:"100%"}}>
                                  <input
                                    type="checkbox"
                                    checked={Boolean(week[firstKey])}
                                    name={firstKey}
                                    onChange={(e) => handleCheckBox(e, index)}
                                  />
                                  <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100%", cursor:"pointer"}}>
                                  <span className="day-name ms-2 ">
                                    {weekName}
                                  </span>
                                  <span className=" text-end" style={{flex:"1 1 0"}}>
                                  {week[firstKey] === 0 && (
                                    <span className="status-badge">
                                      Unavailable
                                    </span>
                                  )}
                                </span>
                                  </div>
                                </div>

                                
                                </div>
                              </div>

                              {/* -------- ROW 2 (Time Selector) ONLY IF ACTIVE -------- */}
                              {week[firstKey] === 1 && (
                                <div className="slot-item time ">
                                  <div className=" slot-box start-time">
                                    <div className="time-label">START</div>
                                    <TimeSelector
                                      timeType="start"
                                      selectedTime={week[secondKey].startTime}
                                      indexNumber={index}
                                      onTimeChange={handleTimeChange}
                                    />
                                  </div>
<i className="fa-solid fa-arrow-right fa-xs arrow-icon" style={{color:" #94a3ba"}}></i>
                                  <div className=" slot-box end-time">
                                    <div className="time-label">END</div>
                                    <TimeSelector
                                      timeType="end"
                                      selectedTime={week[secondKey].endTime}
                                      indexNumber={index}
                                      onTimeChange={handleTimeChange}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}

                       
                      </div>
                    </div>
                     <div className="availability-footer">
                         
                            <div className="slots-save-button">
                              <button
                                className="btn btn-dark"
                                type="button"
                                onClick={handleSaveButton}
                              >
                                Save
                              </button>
                            </div>
                         
                        </div>
                  </div>
                  <div className="schedule-card">
                    <Configuration />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Availability;
